import React, { createContext, useContext } from "react";

/**
 * The sole purpose of this abstraction is to allow Next.js to swap the lazy
 * components with the actual components, because framework handles the chunk splitting.
 * Having a redundant indirection would cause performance regression.
 */
export const createDependencyInjectableComponent = <Props,>(
  DefaultComponent: React.ComponentType<Props> | React.ComponentType
) => {
  const DependencyInjectableComponentContext = createContext(DefaultComponent);

  return {
    useDependencyInjectableComponent: () =>
      useContext(DependencyInjectableComponentContext),
    DependencyInjectableComponentProvider:
      DependencyInjectableComponentContext.Provider,
  };
};
